export default __webpack_public_path__ + "static/media/5_image_3.f5efcc8c.jpg";